const o = {
  name: "Info",
  dimensions: { width: 22, height: 23 },
  content: `

      <g fill="none" stroke="currentColor">
        <path d="M11 21.75C16.5228 21.75 21 17.2728 21 11.75C21 6.22715 16.5228 1.75 11 1.75C5.47715 1.75 1 6.22715 1 11.75C1 17.2728 5.47715 21.75 11 21.75Z" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M11.5 7.25C11.5 7.80228 11.0523 8.25 10.5 8.25C9.94772 8.25 9.5 7.80228 9.5 7.25C9.5 6.69772 9.94772 6.25 10.5 6.25C11.0523 6.25 11.5 6.69772 11.5 7.25Z" fill="currentColor" stroke="currentColor" stroke-width="0.5"/>
        <path d="M11 15.75V10.75H9" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 14.75C8.44772 14.75 8 15.1977 8 15.75C8 16.3023 8.44772 16.75 9 16.75V14.75ZM13 16.75C13.5523 16.75 14 16.3023 14 15.75C14 15.1977 13.5523 14.75 13 14.75V16.75ZM9 16.75H13V14.75H9V16.75Z" fill="currentColor" stroke="none"/>
      </g>

    `
};
export {
  o as Info
};
